import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

/**
 * GenerateAfastamentoColumnsDefinition
 */

type Props = {
  handleActionEdit: (idDependente: number | null) => void,
  handleActionDelete: (idDependente: number) => void,
};

export const GenerateAfastamentoColumnsDefinition = ({
  handleActionEdit,
  handleActionDelete,
}: Props): GridColDef[] => {
  return [
    {
      field: "motivoAfastamento",
      filterable: false,
      headerName: "Motivo Afastamento",
      flex: 1,
      minWidth: 120,
      sortable: false,
    },
    {
      field: "dataInicio",
      filterable: false,
      headerName: "Data De Início",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return <div>{params.value && dayjs(params.value).format("DD/MM/YYYY")}</div>;
      }
    },
    {
      field: "dataTermino",
      filterable: false,
      headerName: "Data De Término",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return <div>{params.value && dayjs(params.value).format("DD/MM/YYYY")}</div>;
      }
    },
    {
      field: "observacao",
      filterable: false,
      headerName: "Observação",
      flex: 1,
      minWidth: 120,
      sortable: false,
    },
    {
      field: 'idAfastamento',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      flex: 0,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => handleActionEdit(params.value)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => handleActionDelete(params.value)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      },
    }
  ];
}